"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleService = void 0;
const PreviewConstant_1 = require("./PreviewConstant");
const PreviewUtil_1 = require("./PreviewUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class TitleService {
    constructor(brainClient) {
        this.brainClient = brainClient;
    }
    async generateTitle(input) {
        const params = {
            identifier_type: "file",
            identifier_value: "brain_studios_saas_app_title_generation.model",
            stream: false,
            variables: { input },
        };
        const res = await this.brainClient.openAi.completionsGenerationV2(params);
        const responseTitle = PreviewUtil_1.PreviewUtil.getTitleFromResponse(res);
        const defaultTitle = responseTitle.title || PreviewConstant_1.PreviewConstant.webAppDefaultTitle;
        // bsf-6211 将 subtitle 默认为空了
        const defaultSubTitle = responseTitle.subTitle || "";
        return { title: defaultTitle, subTitle: defaultSubTitle };
    }
    async getAppTitle(input, flow) {
        if ((0, is_blank_1.default)(flow.title) === false && (0, is_blank_1.default)(flow.description) === false) {
            // 如果cot返回了title 则优先使用
            return {
                title: flow.title,
                subTitle: flow.description,
            };
        }
        const extraSaasUIData = await this.generateTitle(input);
        return extraSaasUIData;
    }
}
exports.TitleService = TitleService;
